import { render, staticRenderFns } from "./ReturnTable.vue?vue&type=template&id=c4b631ee&"
import script from "./ReturnTable.vue?vue&type=script&lang=js&"
export * from "./ReturnTable.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b631ee')) {
      api.createRecord('c4b631ee', component.options)
    } else {
      api.reload('c4b631ee', component.options)
    }
    module.hot.accept("./ReturnTable.vue?vue&type=template&id=c4b631ee&", function () {
      api.rerender('c4b631ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnTable.vue"
export default component.exports